import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookOpen,
  faQuoteLeft,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import {} from "@fortawesome/free-regular-svg-icons";
import {} from "@fortawesome/free-brands-svg-icons";
import { Carousel, Card, Button } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import "./BecomeTutor.css";
import $ from "jquery";
import HeaderSub from "../HeaderSub/HeaderSub";

export default () => {
  {
    $(".frequently-qstn .btn-link").click(function () {
      if ($(this).parent().hasClass("show-clr")) {
        $(this).parent().removeClass("show-clr");
      } else {
        $(".frequently-qstn .card-header").removeClass("show-clr");
        $(this).parent().addClass("show-clr");
      }
    });
  }
  return (
    <div className="container">
      <div className="tutor-overview  float-left w-100">
        {/* header */}
        <HeaderSub/>
        {/* top-section */}
        <div className="become-top-m float-left w-100">
          <div className="">
            <div className="row m-0">
              <div className="col-12">
                <div className="become-top float-left w-100">
                  <div className="earnbox">
                    <h3>Earn money teaching the subject you love.</h3>
                    <label>Find out what you could earn</label>
                    <form>
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6">
                          <div className="fields float-left w-100">
                            <input
                              type="text"
                              name="subject"
                              placeholder="search your subject"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6">
                          <div className="fields float-left w-100">
                            <select>
                              <option>your level</option>
                              <option>your level</option>
                              <option>your level</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-12">
                          <span className="price-tag">Montly £ 1200</span>
                        </div>
                        <div className="col-12">
                          <button>Get Started</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* wh-tutor*/}
        <div className="why-tutor-m float-left w-100">
          <div className="">
            <div className="float-left w-100">
              <div className="why-content">
                <h3>Why tutor on Askademia?</h3>
                <p>
                  Lorem ipsum dolor sit amet, qui ex velit scaevola percipitur,
                  cum alienum verterem in, sit liber iusto convenire ad. Vim id
                  quot quando, cum ne hinc aliquam commune, mel an possit
                  quaerendum ullamcorper. Ne suas tibique officiis vix mel an
                  possit quaerendum ullamcorper. Ne suas tibique officiis vix
                </p>
              </div>
              <div className="why-img">
                <img
                  src={require("../../assets/images/why-img.png")}
                  srcSet={`
                      ${require("../../assets/images/why-imgm.png")} 450w, 
                      ${require("../../assets/images/why-img.png")}
                      `}
                  alt="banner"
                />
              </div>
              <div className="why-img img2">
                <img
                  src={require("../../assets/images/why-img2.png")}
                  srcSet={`
                      ${require("../../assets/images/why-img2m.png")} 450w, 
                      ${require("../../assets/images/why-img2.png")}
                      `}
                  alt="banner"
                />
              </div>
              <div className="why-content content-2">
                <h3>We support you all the way</h3>
                <p>
                  Lorem ipsum dolor sit amet, qui ex velit scaevola percipitur,
                  cum alienum verterem in, sit liber iusto convenire ad. Vim id
                  quot quando, cum ne hinc aliquam commune, mel an possit
                  quaerendum ullamcorper. Ne suas tibique officiis vix mel an
                  possit quaerendum ullamcorper. Ne suas tibique officiis vix
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* how work */}
        <div className="work-m float-left w-100">
          <div className="">
            <div className="row">
              <div className="col-12">
                <div className="work-head float-left w-100">
                  <h1>How it works</h1>
                </div>
              </div>
              <div className="workk float-left w-100" id="one">
                <div className="">
                  <div className="row">
                    <div className="col-lg-5 col-md-6 col-12">
                      <div className="work-left float-left w-100">
                        <div className="work-count float-left w-100">
                          <span>01</span>
                        </div>
                        <div className="after-style first-style">
                          <div className="work-content">
                            <h3>List taught subjects</h3>
                            <p>
                              Lorem ipsum dolor sit amet, qu ve scaevola cum
                              alienum verterem in, sit liber iusto Rem amet,
                              consectetur adipisicing elit, sed do eiusmo dipsum
                              dolor sit amet, consectetur
                            </p>
                          </div>
                          <span className="circle-back">
                            <span className="circle"></span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="offset-1"></div>
                    <div className="col-lg-5 col-md-5 col-12">
                      <div className="work-img float-left w-100">
                        <FontAwesomeIcon icon={faBookOpen} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="workk float-left w-100" id="two">
                <div className="">
                  <div className="row">
                    <div className="col-lg-5 col-md-5 col-12">
                      <div className="after-style">
                        <div className="work-img float-left w-100">
                          <FontAwesomeIcon icon={faBookOpen} />
                        </div>
                        <span className="circle-back">
                          <span className="circle"></span>
                        </span>
                      </div>
                    </div>
                    <div className="offset-1"></div>
                    <div className="col-lg-5 col-md-6 col-12">
                      <div className="work-left float-left w-100">
                        <div className="work-count float-left w-100">
                          <span>02</span>
                        </div>
                        <div className="work-content">
                          <h3>List taught subjects</h3>
                          <p>
                            Lorem ipsum dolor sit amet, qu ve scaevola cum alienum
                            verterem in, sit liber iusto Rem amet, consectetur
                            adipisicing elit, sed do eiusmo dipsum dolor sit amet,
                            consectetur
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="workk float-left w-100" id="one">
                <div className="">
                  <div className="row">
                    <div className="col-lg-5 col-md-6 col-12">
                      <div className="work-left float-left w-100">
                        <div className="work-count float-left w-100">
                          <span>03</span>
                        </div>
                        <div className="after-style three-style">
                          <div className="work-content">
                            <h3>List taught subjects</h3>
                            <p>
                              Lorem ipsum dolor sit amet, qu ve scaevola cum
                              alienum verterem in, sit liber iusto Rem amet,
                              consectetur adipisicing elit, sed do eiusmo dipsum
                              dolor sit amet, consectetur
                            </p>
                          </div>
                          <span className="circle-back">
                            <span className="circle"></span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="offset-1"></div>
                    <div className="col-lg-5 col-md-5 col-12">
                      <div className="work-img float-left w-100">
                        <FontAwesomeIcon icon={faBookOpen} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="workk float-left w-100" id="two">
                <div className="">
                  <div className="row">
                    <div className="col-lg-5 col-md-5 col-12">
                      <div className="after-style four-style">
                        <div className="work-img float-left w-100">
                          <FontAwesomeIcon icon={faBookOpen} />
                        </div>
                        <span className="circle-back">
                          <span className="circle"></span>
                        </span>
                      </div>
                    </div>
                    <div className="offset-1"></div>
                    <div className="col-lg-5 col-md-6 col-12">
                      <div className="work-left float-left w-100">
                        <div className="work-count float-left w-100">
                          <span>04</span>
                        </div>
                        <div className="work-content">
                          <h3>List taught subjects</h3>
                          <p>
                            Lorem ipsum dolor sit amet, qu ve scaevola cum alienum
                            verterem in, sit liber iusto Rem amet, consectetur
                            adipisicing elit, sed do eiusmo dipsum dolor sit amet,
                            consectetur
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* mid-section */}
        <div className="mid-section-m float-left w-100">
          <div className="">
            <div className="row">
              <div className="col-lg-7 col-md-7 col-12">
                <div className="mid-section-left float-left w-100">
                  <FontAwesomeIcon icon={faQuoteLeft} />
                  <h2>Lorem ipsum dolor sit ametpercipiturcum </h2>
                  <p>Lorem ipsum dolor sit amet, qu ve scaevola cum alienum</p>
                  <div className="start-btn float-left w-100">
                    <a href="#">Get Started</a>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-5 col-12">
                <div className="mid-section-right float-left w-100">
                  <img
                    src={require("../../assets/images/mid-section.jpg")}
                    srcSet={`
                      ${require("../../assets/images/mid-sectionm.jpg")} 450w, 
                      ${require("../../assets/images/mid-section.jpg")}
                      `}
                    alt="banner"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* we provide */}
        <div className="provide-m float-left w-100">
          <div className="">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12">
                <div className="provide-left float-left w-100">
                  <img
                    src={require("../../assets/images/provide.png")}
                    srcSet={`
                      ${require("../../assets/images/providem.png")} 450w, 
                      ${require("../../assets/images/provide.png")}
                      `}
                    alt="banner"
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <div className="provide-right float-left w-100">
                  <h2>We provide exclusive Coaching Insurance Benifits</h2>
                  <p>
                    Lorem ipsum dolor sit amet, qui ex velit scaevola percipi tur,
                    cum alienum verterem in, sit liber iusto convenire ad. Vim id
                    quot quando.
                  </p>
                  <ul>
                    <li>
                      <FontAwesomeIcon icon={faCheckCircle} />{" "}
                      <span>Make a difference</span>
                    </li>
                    <li>
                      <FontAwesomeIcon icon={faCheckCircle} />{" "}
                      <span>Vim id quot du be hinc aliquam commune</span>
                    </li>
                    <li>
                      <FontAwesomeIcon icon={faCheckCircle} />{" "}
                      <span>In cum quot refirnuda</span>
                    </li>
                    <li>
                      <FontAwesomeIcon icon={faCheckCircle} />{" "}
                      <span>Ne suas tibique officiis vix, cu causae prompta</span>
                    </li>
                  </ul>
                  <div className="start-btn float-left w-100">
                    <a href="#">Learn How They Tutor</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* payment */}
        <div className="payment-m float-left w-100">
          <div className="">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12">
                <div className="payment-left float-left w-100">
                  <h3>Plan Your curriculam</h3>
                  <p>
                    Lorem ipsum dolor sit amet, qui ex velit scaevola percipi tur,
                    Vim id quot quando. Lorem ipsum dolor sit amet, qui ex liber
                    iusto convenire ad Vim id quot quando.
                  </p>
                  <h3>Pay low fees</h3>
                  <p>
                    Lorem ipsum dolor sit amet, qui ex velit scaevola percipi tur,
                    Vim id quot quando. Lorem ipsum dolor sit amet, qui ex liber
                    iusto convenire ad Vim id quot quando.
                  </p>
                  <h3>Earn aquich income</h3>
                  <p>
                    Lorem ipsum dolor sit amet, qui ex velit scaevola percipi tur,
                    Vim id quot quando. Lorem ipsum dolor sit amet, qui ex liber
                    iusto convenire ad Vim id quot quando.
                  </p>
                  <label>Nec quas nusquam efficiantu</label>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <div className="payment-right"></div>
              </div>
            </div>
          </div>
        </div>
        {/* instrucot-testimonial */}
        <div className="instructor-testimonail-m float-left w-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 col-md-8 col-sm-12 pl-lg-0 pl-md-0">
                <div className="instructor-content float-left w-100">
                  <span>
                    <FontAwesomeIcon icon={faQuoteLeft} />
                  </span>
                  <h2>
                    What Our
                    <br />
                    Instructor Are
                    <br /> Saying
                  </h2>
                </div>
                <div className="instructor-testimonial">
                  <Carousel>
                    <Carousel.Item>
                      <div className="instructor-detail-m float-left w-100">
                        <p>
                          Tutoring has helped me make money at university whilst
                          still having the time to study for a demanding medical
                          degree.Lorem ipsum dolor sit amet,
                        </p>
                        <div className="instructor-img">
                          <img
                            src={require("../../assets/images/instructor.jpg")}
                            alt="banner"
                          />
                        </div>
                        <div className="instructor-detail">
                          <label>Ichan Fadhil</label>
                          <span>Bachelor in Physics</span>
                        </div>
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="instructor-detail-m float-left w-100">
                        <p>
                          Tutoring has helped me make money at university whilst
                          still having the time to study for a demanding medical
                          degree.Lorem ipsum dolor sit amet,
                        </p>
                        <div className="instructor-img">
                          <img
                            src={require("../../assets/images/instructor.jpg")}
                            alt="banner"
                          />
                        </div>
                        <div className="instructor-detail">
                          <label>Ichan Fadhil</label>
                          <span>Bachelor in Physics</span>
                        </div>
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="instructor-detail-m float-left w-100">
                        <p>
                          Tutoring has helped me make money at university whilst
                          still having the time to study for a demanding medical
                          degree.Lorem ipsum dolor sit amet,
                        </p>
                        <div className="instructor-img">
                          <img
                            src={require("../../assets/images/instructor.jpg")}
                            alt="banner"
                          />
                        </div>
                        <div className="instructor-detail">
                          <label>Ichan Fadhil</label>
                          <span>Bachelor in Physics</span>
                        </div>
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="instructor-detail-m float-left w-100">
                        <p>
                          Tutoring has helped me make money at university whilst
                          still having the time to study for a demanding medical
                          degree.Lorem ipsum dolor sit amet,
                        </p>
                        <div className="instructor-img">
                          <img
                            src={require("../../assets/images/instructor.jpg")}
                            alt="banner"
                          />
                        </div>
                        <div className="instructor-detail">
                          <label>Ichan Fadhil</label>
                          <span>Bachelor in Physics</span>
                        </div>
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className="instructor-detail-m float-left w-100">
                        <p>
                          Tutoring has helped me make money at university whilst
                          still having the time to study for a demanding medical
                          degree.Lorem ipsum dolor sit amet,
                        </p>
                        <div className="instructor-img">
                          <img
                            src={require("../../assets/images/instructor.jpg")}
                            alt="banner"
                          />
                        </div>
                        <div className="instructor-detail">
                          <label>Ichan Fadhil</label>
                          <span>Bachelor in Physics</span>
                        </div>
                      </div>
                    </Carousel.Item>
                  </Carousel>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* about */}
        <div className="about-m float-left w-100">
          <div className="">
            <div className="row">
              <div className="col-12">
                <div className="main-head float-left w-100">
                  <h1>About Askademia</h1>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <div className="about float-left w-100">
                  <h3>What is Askademia?</h3>
                  <p>
                    Lorem ipsum dolor sit amet, qui ex velit scaevola percipi tur,
                    Vim id quot quando. Lorem ipsum dolor sit amet, qui ex liber
                    iusto convenire ad Vim id quot quando.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <div className="about float-left w-100">
                  <h3>What is tutoring</h3>
                  <p>
                    Lorem ipsum dolor sit amet, qui ex velit scaevola percipi tur,
                    Vim id quot quando. Lorem ipsum dolor sit amet, qui ex liber
                    iusto convenire ad Vim id quot quando.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* frequently qstn */}
        <div className="frequently-qstn-m float-left w-100">
          <div className="">
            <div className="row">
              <div className="col-12">
                <div className="main-head float-left w-100">
                  <h1>Frequently asked questions</h1>
                </div>
              </div>
              <div className="col-12">
                <div className="frequently-qstn float-left w-100">
                  <Accordion defaultActiveKey="0">
                    <Card>
                      <Card.Header className="show-clr">
                        <Accordion.Toggle as={Button} variant="link" eventKey="0">
                          Who can be an Askademia tutor?
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="0">
                        <Card.Body>
                          Lorem ipsum dolor sit amet, qui ex velit scaevola
                          percipi tur, cum alienum verterem in, sit liber iusto
                          Vim id quot quando. Lorem ipsum dolor
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="1">
                          What is required of tutors before tutoring?
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="1">
                        <Card.Body>
                          Lorem ipsum dolor sit amet, qui ex velit scaevola
                          percipi tur, cum alienum verterem in, sit liber iusto
                          Vim id quot quando. Lorem ipsum dolor
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="2">
                          How much does it cost to register as a tutor?
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="2">
                        <Card.Body>
                          Lorem ipsum dolor sit amet, qui ex velit scaevola
                          percipi tur, cum alienum verterem in, sit liber iusto
                          Vim id quot quando. Lorem ipsum dolor
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="3">
                          What insurance protection do I have as a tutor?
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="3">
                        <Card.Body>
                          Lorem ipsum dolor sit amet, qui ex velit scaevola
                          percipi tur, cum alienum verterem in, sit liber iusto
                          Vim id quot quando. Lorem ipsum dolor
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="4">
                          How should I choose my session prices?
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="4">
                        <Card.Body>
                          Lorem ipsum dolor sit amet, qui ex velit scaevola
                          percipi tur, cum alienum verterem in, sit liber iusto
                          Vim id quot quando. Lorem ipsum dolor
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Card.Header>
                        <Accordion.Toggle as={Button} variant="link" eventKey="5">
                          What subjects I can teach?
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="5">
                        <Card.Body>
                          Lorem ipsum dolor sit amet, qui ex velit scaevola
                          percipi tur, cum alienum verterem in, sit liber iusto
                          Vim id quot quando. Lorem ipsum dolor
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* tutor-bottom */}
        <div className="container">
          <div className="tutor-bottom-m float-left w-100">
            <div className="container">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-12">
                  <div className="tutor-bottom float-left w-100">
                    <div className="tutor-img float-left w-100">
                      <img
                        src={require("../../assets/images/tutor-Bimg.jpg")}
                        srcSet={`
                        ${require("../../assets/images/tutor-Bimg.jpg")} 450w, 
                        ${require("../../assets/images/tutor-Bimg.jpg")}
                    `}
                        alt="tutor-img"
                      />
                    </div>
                    <div className="tutor-content float-left w-100">
                      <p>
                        Hana tutors in London to share her love for biology Lorem
                      </p>
                      <a href="#">Learn More</a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-12">
                  <div className="tutor-bottom float-left w-100">
                    <div className="tutor-img float-left w-100">
                      <img
                        src={require("../../assets/images/tutor-Bimg2.jpg")}
                        srcSet={`
                        ${require("../../assets/images/tutor-Bimg2m.jpg")} 450w, 
                        ${require("../../assets/images/tutor-Bimg2.jpg")}
                    `}
                        alt="tutor-img"
                      />
                    </div>
                    <div className="tutor-content float-left w-100">
                      <p>
                        Hana tutors in London to share her love for biology Lorem
                      </p>
                      <a href="#">Learn More</a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-12">
                  <div className="tutor-bottom float-left w-100">
                    <div className="tutor-img float-left w-100">
                      <img
                        src={require("../../assets/images/tutor-Bimg3.jpg")}
                        srcSet={`
                        ${require("../../assets/images/tutor-Bimg3m.jpg")} 450w, 
                        ${require("../../assets/images/tutor-Bimg3.jpg")}
                    `}
                        alt="tutor-img"
                      />
                    </div>
                    <div className="tutor-content float-left w-100">
                      <p>
                        Hana tutors in London to share her love for biology Lorem
                      </p>
                      <a href="#">Learn More</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ready-to */}
        <div className="ready-to-m float-left w-100 mb-5">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="ready-to float-left w-100">
                  <h3>Ready to tutoring?</h3>
                  <div className="start-btn float-left w-100">
                    <a href="#">Get Started</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="overlay"></div>
        </div>
      </div>
    </div>  
  );
};
